import jobs from './jobs';
import shifts from './shifts';
import layout from './layout';
import passengers from './passengers';

const index = {
  jobs,
  shifts,
  layout,
  passengers
};

export default index;
